module.exports = __webpack_public_path__ + "img/arrow-down.e86d8131.svg";